export const intraComCountries = [
  "Germany",
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Denmark",
  "Spain",
  "Estonia",
  "Finland",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Poland",
  "Portugal",
  "Czech Republic",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Sweden",
];
